/* eslint-disable */
import React from "react";
import { assetImages } from "constants";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const StopTaskWarningModal = ({ onStop = () => {} }) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  return (
    <div
      className="modal fade"
      id="stoptaskwarning"
      tabIndex="-1"
      aria-labelledby="stoptaskwarninglabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-body text-center px-4 py-5">
            <img
              src={assetImages.exclamationIcon}
              alt="warning"
              className="img-fluid"
            />
            <h2>
              {t("Are you sure")} , <br /> {t("You want to end the day now")}?
            </h2>
            {/* <h3>** Task with logs can't be deleted</h3> */}
            <div className="d-flex gap-3 justify-content-center">
              <Link
                to="#"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {t("No")}, {t("Stay In Progress")}
              </Link>

              <Link
                to="#"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onStop}
              >
                {t("Yes")}, {t("Complete it Now")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StopTaskWarningModal;
